export default {
  items: [
    {
      title: true,
      name: 'Geral',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Banners',
      url: {
        name: 'manageables.index',
        params: { entity: 'bl-banners' }
      },
      icon: 'icon-picture'
    },
    {
      name: 'Dúvidas Frequentes',
      url: {
        name: 'manageables.index',
        params: { entity: 'bl-questions' }
      },
      icon: 'icon-question'
    },
    {
      name: 'Currículos',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-resumes'
        }
      },
      icon: 'fa fa-user-circle'
    },
    // {
    //   divider: true
    // },
    {
      title: true,
      name: 'Processos',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Tipos de processo',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-process-types'
        }
      },
      icon: 'icon-list'
    },
    {
      name: 'Processos',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-processes'
        }
      },
      icon: 'icon-drawer'
    },
    {
      name: 'Categorias',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-process-categories'
        }
      },
      icon: 'fa fa-tags'
    },
    {
      name: 'Arquivos',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-process-items'
        }
      },
      icon: 'fa fa-list-alt'
    },

    // JURISPRUNDENCIA
    {
      title: true,
      name: 'Jurisprudência',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Categorias',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-jurisprudence-categories'
        }
      },
      icon: 'fa fa-tags'
    },
    {
      name: 'Arquivos',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-jurisprudence-files'
        }
      },
      icon: 'icon-docs'
    },

    {
      title: true,
      name: 'Notícias',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Categorias',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-story-categories'
        }
      },
      icon: 'fa fa-tags'
    },
    {
      name: 'Notícias',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-stories'
        }
      },
      icon: 'icon-list'
    },

    {
      title: true,
      name: 'Contatos',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Contatos',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-contacts'
        }
      },
      icon: 'icon-envelope-letter',
      badge: {
        variant: 'success',
        text: null,
        entity: '/bl/contacts',
        search: 'status:0'
      }
    },
    {
      name: 'Trabalhe Conosco',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'bl-career-contacts'
        }
      },
      icon: 'fa fa-address-book-o'
      // badge: {
      //   variant: 'success',
      //   text: null,
      //   entity: '/bl/career-contacts'
      // }
    },
    {
      title: true,
      name: 'Usuários e Permissões',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Usuários',
      url: {
        name: 'manageables.index',
        params: { entity: 'sys-users' }
      },
      icon: 'icon-user'
    },
    {
      name: 'Autorizações',
      url: {
        name: 'bl-authorizations.index'
      },
      icon: 'icon-lock-open',
      badge: {
        variant: 'warning',
        text: null,
        entity: '/bl/authorizations',
        search: 'status:0'
      }
    }
    //   //     {
    //   //       name: 'Carousels',
    //   //       url: '/base/carousels',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Collapses',
    //   //       url: '/base/collapses',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Forms',
    //   //       url: '/base/forms',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Jumbotrons',
    //   //       url: '/base/jumbotrons',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'List Groups',
    //   //       url: '/base/list-groups',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Navs',
    //   //       url: '/base/navs',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Paginations',
    //   //       url: '/base/paginations',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Popovers',
    //   //       url: '/base/popovers',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Progress Bars',
    //   //       url: '/base/progress-bars',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Switches',
    //   //       url: '/base/switches',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Tables',
    //   //       url: '/base/tables',
    //   //       icon: 'icon-puzzle'
    //   //     },
    //   //     {
    //   //       name: 'Tooltips',
    //   //       url: '/base/tooltips',
    //   //       icon: 'icon-puzzle'
    //   //     }
    //   //   ]
    //   // },
    //   // {
    //   //   name: 'Buttons',
    //   //   url: '/buttons',
    //   //   icon: 'icon-cursor',
    //   //   children: [
    //   //     {
    //   //       name: 'Standard Buttons',
    //   //       url: '/buttons/standard-buttons',
    //   //       icon: 'icon-cursor'
    //   //     },
    //   //     {
    //   //       name: 'Button Groups',
    //   //       url: '/buttons/button-groups',
    //   //       icon: 'icon-cursor'
    //   //     },
    //   //     {
    //   //       name: 'Dropdowns',
    //   //       url: '/buttons/dropdowns',
    //   //       icon: 'icon-cursor'
    //   //     },
    //   //     {
    //   //       name: 'Social Buttons',
    //   //       url: '/buttons/social-buttons',
    //   //       icon: 'icon-cursor'
    //   //     }
    //   //   ]
    //   // },
    //   // {
    //   //   name: 'Icons',
    //   //   url: '/icons',
    //   //   icon: 'icon-star',
    //   //   children: [
    //   //     {
    //   //       name: 'Flags',
    //   //       url: '/icons/flags',
    //   //       icon: 'icon-star',
    //   //       badge: {
    //   //         variant: 'success',
    //   //         text: 'NEW'
    //   //       }
    //   //     },
    //   //     {
    //   //       name: 'Font Awesome',
    //   //       url: '/icons/font-awesome',
    //   //       icon: 'icon-star',
    //   //       badge: {
    //   //         variant: 'secondary',
    //   //         text: '4.7'
    //   //       }
    //   //     },
    //   //     {
    //   //       name: 'Simple Line Icons',
    //   //       url: '/icons/simple-line-icons',
    //   //       icon: 'icon-star'
    //   //     }
    //   //   ]
    //   // },
    //   // {
    //   //   name: 'Charts',
    //   //   url: '/charts',
    //   //   icon: 'icon-pie-chart'
    //   // },
    //   // {
    //   //   name: 'Notifications',
    //   //   url: '/notifications',
    //   //   icon: 'icon-bell',
    //   //   children: [
    //   //     {
    //   //       name: 'Alerts',
    //   //       url: '/notifications/alerts',
    //   //       icon: 'icon-bell'
    //   //     },
    //   //     {
    //   //       name: 'Badges',
    //   //       url: '/notifications/badges',
    //   //       icon: 'icon-bell'
    //   //     },
    //   //     {
    //   //       name: 'Modals',
    //   //       url: '/notifications/modals',
    //   //       icon: 'icon-bell'
    //   //     }
    //   //   ]
    //   // },
    //   // {
    //   //   name: 'Widgets',
    //   //   url: '/widgets',
    //   //   icon: 'icon-calculator',
    //   //   badge: {
    //   //     variant: 'primary',
    //   //     text: 'NEW'
    //   //   }
    //   // },
    //   // {
    //   //   divider: true
    //   // },
    //   // {
    //   //   title: true,
    //   //   name: 'Extras'
    //   // },
    //   // {
    //   //   name: 'Pages',
    //   //   url: '/pages',
    //   //   icon: 'icon-star',
    //   //   children: [
    //   //     {
    //   //       name: 'Login',
    //   //       url: '/pages/login',
    //   //       icon: 'icon-star'
    //   //     },
    //   //     {
    //   //       name: 'Register',
    //   //       url: '/pages/register',
    //   //       icon: 'icon-star'
    //   //     },
    //   //     {
    //   //       name: 'Error 404',
    //   //       url: '/pages/404',
    //   //       icon: 'icon-star'
    //   //     },
    //   //     {
    //   //       name: 'Error 500',
    //   //       url: '/pages/500',
    //   //       icon: 'icon-star'
    //   //     }
    //   //   ]
    //   // }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js